import * as React from 'react';

import Row from 'antd/lib/row';
import Col from 'antd/lib/col';

import {
  Props,
} from 'one-ui';
export interface BoxLightHeaderProps extends Props {
  title?: string;
  titleLink?: string;
  screnpopepicbutton?:JSX.Element
}

export const BoxLightHeader = ({
  title,
  titleLink,
  children,
  screnpopepicbutton

}: BoxLightHeaderProps) => (
    <div className="box__top">
      <Row
        type="flex"
        gutter={[16, 16]}
        justify={'space-between'}
      >
        {screnpopepicbutton &&
        <Col>{screnpopepicbutton}</Col>}
        <Col>
          {titleLink ? (
            <a className="box__title">{title}</a>
          ) : (
              <div className="box__title">
                {title}
              </div>
            )}
        </Col>
        <Col>
          <div className="box__actions">
            {children}
          </div>
        </Col>
      </Row>
    </div>
  );

